import React from 'react'
import { format } from 'date-fns'
import { ArrowDownCircle, ArrowUpCircle } from 'lucide-react'
import { StandardColumn } from '../../../../components/StandardPage'
import { StockMovement } from './types'
import { ExitOrEntry } from './style'

export const movementScreenKey = 'stock_movement'

const formatNumber = (num: number) => num.toFixed(2)

const handlePloomesOrderClick = (id: number) => {
  if (id > 1) window.open(`https://app10.ploomes.com/deal/${id}`, '_blank')
}

const renderOrderCell = (item: StockMovement) => {
  const { ploomesOrderId, orderName } = item
  const maxLength = 25
  const truncatedOrderName = orderName && orderName.length > maxLength
    ? orderName.slice(0, maxLength) + '...'
    : orderName
  const tooltipTitle = item.observation || orderName

  if (ploomesOrderId === 0) {
    return (
      <ExitOrEntry title='Entrada' className="flex items-center gap-2 entry">
        <ArrowDownCircle color="green" size={20} />
        <span className='inline-flex' title={tooltipTitle}>{truncatedOrderName}</span>
      </ExitOrEntry>
    )
  }

  if (ploomesOrderId === 1) {
    return (
      <ExitOrEntry title='Saída'>
        <ArrowUpCircle color='red' size={20} />
        <span title={tooltipTitle}>{truncatedOrderName}</span>
      </ExitOrEntry>
    )
  }

  return (
    <span
      title={tooltipTitle}
      onClick={() => handlePloomesOrderClick(ploomesOrderId)}
      style={{ cursor: 'pointer', color: 'blue' }}
    >
      {orderName.substring(0, 25)}...
    </span>
  )
}

const weightCell = (value: number | undefined, isFashion: boolean) => {
  if (value == null) return ''
  return isFashion ? `${formatNumber(value)} kg` : formatNumber(value)
}

export const buildMovementColumns = (isFashion: boolean): StandardColumn<StockMovement>[] => [
  {
    id: 'ploomesOrderId',
    label: 'Pedido',
    cell: (item) => renderOrderCell(item),
    exportValue: (item) => item.orderName,
  },
  { id: 'rawMaterialName', label: 'Código' },
  {
    id: 'quantity',
    label: 'Quantidade',
    cell: (item) => <>{typeof item.quantity === 'number' ? formatNumber(item.quantity) : item.quantity}</>,
    exportValue: (item) => item.quantity,
  },
  {
    id: 'oldTotalWeight',
    label: 'Peso Total Anterior',
    cell: (item) => <>{weightCell(item.oldTotalWeight, isFashion)}</>,
    exportValue: (item) => item.oldTotalWeight,
  },
  {
    id: 'newTotalWeight',
    label: 'Novo Peso Total',
    cell: (item) => <>{weightCell(item.newTotalWeight, isFashion)}</>,
    exportValue: (item) => item.newTotalWeight,
  },
  {
    id: 'oldLengthInMm',
    label: 'Comprimento Anterior (mm)',
    defaultHidden: true,
    cell: (item) => <>{typeof item.oldLengthInMm === 'number' ? formatNumber(item.oldLengthInMm) : ''}</>,
    exportValue: (item) => item.oldLengthInMm,
  },
  {
    id: 'newLengthInMm',
    label: 'Novo Comprimento (mm)',
    defaultHidden: true,
    cell: (item) => <>{typeof item.newLengthInMm === 'number' ? formatNumber(item.newLengthInMm) : ''}</>,
    exportValue: (item) => item.newLengthInMm,
  },
  {
    id: 'status',
    label: 'Status',
    defaultHidden: true,
    cell: (item) => (item.status === '410' ? <>Desfeito</> : item.status === 'Editado' ? <>Editado</> : <>{item.status || 'Abatido'}</>),
    exportValue: (item) => (item.status === '410' ? 'Desfeito' : item.status === 'Editado' ? 'Editado' : (item.status || 'Abatido')),
  },
  {
    id: 'createdAt',
    label: 'Data de Criação',
    defaultHidden: true,
    cell: (item) => <>{format(new Date(item.createdAt), 'dd/MM/yyyy - HH:mm') + 'h'}</>,
    exportValue: (item) => format(new Date(item.createdAt), 'dd/MM/yyyy - HH:mm') + 'h',
  },
]
